import { Pipe, PipeTransform } from '@angular/core';
import { Tournament } from './../../models/tournament';
import { Order } from './../../models/order'
@Pipe({
    name: 'orderFilter',
    pure: false
})
export class OrderPipe implements PipeTransform {
    transform(items: Order[], filter: Order): any {
        if (!items || !filter) {
            return items;
        }
        // filter items array, items which match and return true will be
        // kept, false will be filtered out
        return items.filter((item: Order) => this.applyFilter(item, filter));
    }
    applyFilter(book: Order, filter: Order): boolean {
        for (let field in filter) {
            // console.log(filter[field]+"       "+book[field]+"  "+(filter[field]==book[field])+"  "+(filter[field]===book[field]))
            if (book[field]) {
                if (filter[field]) {
                    if (typeof filter[field] === 'string') {

                        if (book[field].toLowerCase().indexOf(filter[field].toLowerCase()) === -1) {
                            return false;
                        }
                    } else if (typeof filter[field] === 'number') {
                        if (book[field] !== filter[field]) {
                            return false;
                        }
                    } else if (filter[field] == 'date') {
                        if (book[field] !== filter[field]) {
                            return false;
                        }
                    }
                }
            }

        }
        return true;
    }
}